(function () {
  var root = document.getElementById('KdcEmailPopup');
  if (!root) return;

  var LS_DONE = 'kdcp2-done';        // signed up → never show again
  var LS_CLOSED = 'kdcp2-closed-at'; // dismissed → suppress 30 days
  var SUPPRESS_MS = 30 * 24 * 3600 * 1000;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // After a successful Shopify customer-form post the page reloads with
  // customer_posted=true → show the success state with the code once.
  var posted = /[?&]customer_posted=true/.test(location.search);
  if (posted) {
    lsSet(LS_DONE, '1');
    var formState = root.querySelector('[data-kdcp-form-state]');
    var success = root.querySelector('[data-kdcp-success]');
    if (formState) formState.hidden = true;
    if (success) success.hidden = false;
    root.hidden = false;
    bindClose();
    return;
  }

  // Preview mode: append ?kdcp=test to any page URL to force the popup open
  // immediately, ignoring the "already closed / already signed up" memory.
  var testMode = /[?&]kdcp=test/.test(location.search);

  if (!testMode && lsGet(LS_DONE)) return;
  var closedAt = parseInt(lsGet(LS_CLOSED) || '0', 10);
  if (!testMode && closedAt && Date.now() - closedAt < SUPPRESS_MS) return;

  var shown = false;
  function show() {
    if (shown) return;
    shown = true;
    root.hidden = false;
    bindClose();
  }

  function close() {
    root.hidden = true;
    lsSet(LS_CLOSED, String(Date.now()));
  }

  function bindClose() {
    root.querySelectorAll('[data-kdcp-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
    // Primary CTA: cart has items → straight to checkout; empty cart →
    // close and bring them back to the buy box.
    var buyBtn = root.querySelector('[data-kdcp-buy]');
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart && cart.item_count > 0) {
              window.location.href = '/cart/checkout';
            } else {
              close();
              var atc = document.querySelector('[id^="KDC-AddToCart"]');
              if (atc) atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          })
          .catch(function () { close(); });
      });
    }
  }

  if (testMode) { show(); return; }

  // Exit intent ONLY — never on a timer, so the popup can't interrupt
  // someone who is reading or adding to cart.

  // Desktop: pointer leaves through the top of the viewport (going for the
  // tab bar / close button / URL bar).
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) show();
  });

  // Mobile has no cursor, so we approximate exit intent with the two signals
  // that precede leaving: a fast scroll back toward the top after having
  // read a good chunk of the page (thumb-flick toward the URL bar / back
  // button), or the tab being backgrounded and then returning.
  var deepestY = 0;
  var lastY = window.scrollY;
  var lastT = Date.now();
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    var now = Date.now();
    if (y > deepestY) deepestY = y;
    var dt = now - lastT;
    var dy = lastY - y; // positive = scrolling up
    // Engaged (scrolled > 1.5 screens), now near the top again after a fast
    // upward flick → likely leaving.
    if (
      deepestY > window.innerHeight * 1.5 &&
      dy > 0 && dt > 0 && dy / dt > 1.2 && // > ~1200 px/s upward
      y < window.innerHeight * 0.4
    ) show();
    lastY = y;
    lastT = now;
  }, { passive: true });

  // Returning to the tab after switching away (mobile app-switch / desktop
  // tab-switch): they came back — one gentle chance to catch them.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && deepestY > window.innerHeight * 1.5) show();
  });
})();
